import { useState } from "react";
import React from "react";
import CouponModal from "./CouponModal";
import { CouponListDto } from "@interfaces/dto/coupon.dto";
import Pagination from "@components/atoms/Pagination";
import { COUPON_PAGE_SIZE } from "@const/products.const";
import { CouponType } from "@interfaces/dto/coupon.dto";
import NoCoupon from "./NoCoupon";
import { collectCoupon } from "@api/coupon/coupon";
import { errorToast } from "@utils/toast";
import { commonToast } from "@utils/toast";
import { useRouter } from "next/router";
import { LOGIN_ROUTE_PATH } from "@const/route-paths.const";

interface Props {
  selectedStatus?: CouponType | undefined;
  couponList: CouponListDto | undefined;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  customerId?: number;
  couponMutate: () => void;
}

export const CouponImage = (data: any) => ({
  backgroundSize: data.image_url ? "100%" : "60%",
  backgroundImage: data.image_url
    ? `url(${data.image_url})`
    : 'url("/assets/images/topvalue_shipping.png")',
});

const CouponItem = ({
  couponList,
  selectedStatus,
  currentPage,
  setCurrentPage,
  customerId,
  couponMutate,
}: Props) => {
  const router = useRouter();

  const [modalCouponActive, setModalCouponActive] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState<any | null>(null);

  const handleShowModal = (coupon: any) => {
    setModalCouponActive(true);
    setSelectedCoupon(coupon);
  };

  const handleCloseModal = () => {
    setModalCouponActive(false);
  };

  const [loadingBtn, setLoadingBtn] = useState<{ [key: string]: boolean }>(
    {}
  );

  const handleCollectCoupon = async (
    coupon: any,
    e: React.MouseEvent<HTMLButtonElement>
  ) => {
    e.stopPropagation();

    const couponId = coupon.coupon_id;

    setLoadingBtn((prevState) => ({
      ...prevState,
      [couponId]: true,
    }));

    if (customerId) {
      const { isOk, message } = await collectCoupon({
        coupon: {
          rule_id: coupon.rule_id,
          pk_coupon_id: couponId,
          customer_id: customerId,
        },
      });

      if (isOk) {
        commonToast({ isOk, message });
        couponMutate();
      } else {
        errorToast(message);
      }

      setLoadingBtn((prevState) => ({
        ...prevState,
        [couponId]: false,
      }));

    } else {
      router.push(LOGIN_ROUTE_PATH);
      setLoadingBtn((prevState) => ({
        ...prevState,
        [couponId]: false,
      }));
    }
  };

  return (
    <>
      <CouponModal
        handleCloseModal={handleCloseModal}
        isShow={modalCouponActive}
        couponData={selectedCoupon}
        selectedStatus={selectedStatus}
      />
      <div className="row list-coupon mx-0 mx-lg-0 mx-md-2 px-0 px-lg-0 px-md-4">
        {couponList && couponList.items && couponList.items.length > 0 ? (
          couponList.items.map((item, itemIndex) => (
            <div key={itemIndex} className="col-lg-6 mb-2 px-0 px-sm-2">
              <a
                onClick={() => handleShowModal(item)}
                className="coupon-item d-flex py-3 py-sm-0 mx-0 mb-2 border rounded"
              >
                <div className="d-flex" style={{ width: "75%" }}>
                  <div className="img-coupon d-flex justify-content-center p-2">
                    <i
                      style={CouponImage(item)}
                      className={`icon ${
                        selectedStatus === "coupon_used" ||
                        selectedStatus === "coupon_expired"
                          ? "icon-coupon-disable"
                          : "icon-coupon-enable"
                      } my-auto img-fluid`}
                    />
                  </div>
                  <div className="w-100 my-auto">
                    <p className="ms-1 ms-sm-3 mb-0 lh-base">
                      <b>คูปอง</b>{" "}
                      <b
                        className={`${
                          selectedStatus === "coupon_used" ||
                          selectedStatus === "coupon_expired"
                            ? "text-secondary"
                            : "text-red"
                        } `}
                      >
                        {item.coupon}
                      </b>{" "}
                      <br />
                      <small className="campaign mt-1 fs-12">
                        {item.campaign_name}
                      </small>
                      <small className="coupon-date text-secondary">
                        ระยะเวลาการใช้งาน : {item.from_date} - {item.to_date}
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  className="my-auto px-0 px-sm-4 px-lg-1 text-center text-lg-center"
                  style={{ width: "25%" }}
                >
                  {item.collect_coupon ||
                  selectedStatus === "collect_coupon" ? (
                    <p className="my-auto text-primary">เก็บแล้ว</p>
                  ) : item.usage_limit ? (
                    <p className="btn btn-gray btn-coupon-status px-1 my-auto">
                      <span className="my-auto text-white">คูปองหมด</span>
                    </p>
                  ) : selectedStatus === "coupon_expired" ? (
                    <p className="my-auto text-secondary">หมดอายุ</p>
                  ) : selectedStatus === "coupon_used" ? (
                    <p className="my-auto text-secondary">ใช้แล้ว</p>
                  ) : (
                    <button
                      className="btn btn-red btn-coupon-status px-1"
                      onClick={(e) => handleCollectCoupon(item, e)}
                      disabled={loadingBtn[item.coupon_id]}
                    >
                      <p className="my-auto text-white">เก็บคูปอง</p>
                    </button>
                  )}
                </div>
              </a>
            </div>
          ))
        ) : (
          <NoCoupon />
        )}

        {couponList && couponList.items && couponList.items.length > 0 && (
          <Pagination
            totalItem={couponList.total_count}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageSize={COUPON_PAGE_SIZE}
          />
        )}
      </div>
    </>
  );
};

export default CouponItem;
